import { InjectionToken, Provider } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { merge } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RouterUserService } from '../api/user.service';
import { IdentityState } from '../common/auth/identity.state';
import { Initializer, INITIALIZER } from '../initialize';

export const INTERCOM_ID = new InjectionToken<string>('INTERCOM_ID');

export function intercomInitalizer(
  identity: IdentityState,
  intercomId: string,
  router: Router,
  userService: RouterUserService,
): Initializer {
  const identityListen = identity.noErrorValue.pipe(
    tap(async identity => {
      if (identity && identity.type != 'unauthorized') {
        const user = (await userService.getUser(identity.id).toPromise())!;
        //to avoid user id collisions append -demo to users outside of prod
        const intercomUserId =
          CONFIG.environment === 'prod'
            ? identity.id.toString()
            : `${identity.id}-${CONFIG.environment}`;

        const userHash = (await userService
          .getIntercomHash(identity.id)
          .toPromise())!;

        Intercom('boot', {
          app_id: intercomId,
          custom_launcher_selector: '.rv-intercom-selector',
          hide_default_launcher: true,
          email: user.email,
          name: user.name,
          user_id: intercomUserId,
          user_hash: userHash.userHash,
        });
        Intercom('update');
      } else {
        Intercom('shutdown');
        Intercom('boot', {
          app_id: intercomId,
          custom_launcher_selector: '.rv-intercom-selector',
          hide_default_launcher: true,
        });
      }
    }),
  );
  const routeListen = router.events.pipe(
    tap(event => {
      if (!(event instanceof NavigationEnd)) {
        return;
      }
      Intercom('update');
    }),
  );
  return merge(identityListen, routeListen);
}

export const INTERCOM_PROVIDERS: Provider[] = [
  {
    deps: [IdentityState, INTERCOM_ID, Router, RouterUserService],
    multi: true,
    provide: INITIALIZER,
    useFactory: intercomInitalizer,
  },
];
